import { select } from 'redux-saga/effects';

import { GeneratorResult } from '@pressreader/appstore';

import { selectInfoGeneration } from '../../selectors/issueinfo';

/**
 * A cached issue/calendar entry stamps the `infoGeneration` it was loaded at.
 * `purchaseDone` bumps `infoGeneration`; an entry whose stamp no longer matches
 * is stale and its loader should re-fetch instead of serving it. The caller owns
 * the `loading` lifecycle check — this only answers the generation question.
 */
export function* isGenerationCurrent(entry: { generation: number }): GeneratorResult<boolean> {
    const infoGeneration: ReturnType<typeof selectInfoGeneration> = yield select(selectInfoGeneration);
    return entry.generation === infoGeneration;
}
